import React from "react";
import { useTest } from "./useTest";
import ToastNotification from "../../component/ToastNotification";
import Folder from "../../assets/folder.png";
import moment from "moment";

const TestPage = () => {
  const { testInfo, loadingData, testResult, isAlreadySummited, handleCard } =
    useTest();

  return (
    <div className="grid gap-5 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 mt-10">
      {testInfo?.loading ? (
        loadingData?.map((_, i) => (
          <div key={i} className="animate-pulse h-32 bg-gray-200 rounded"></div>
        ))
      ) : testInfo?.data?.length ? (
        testInfo?.data?.map((x) => (
          <div
            onClick={() => handleCard(x)}
            className="flex gap-2 w-full cursor-pointer rounded p-4 bg-white shadow-md hover:shadow-lg transition duration-300 relative"
          >
            {x.Type === "Folder" ? (
              <img src={Folder} className="h-32" />
            ) : (
              <img src={x?.ImgIcon} className="h-32" />
            )}
            <div key={x?.objectId} className="flex flex-col gap-5 p-4 ">
              {/* Title and description */}
              <span className="text-xl font-bold text-blue-600">
                {x?.TestTitle}
              </span>
              <span className="text-gray-700">{x?.TestDesc}</span>
              {x?.TestFromDate && x?.TestToDate && (
                <span className="text-teal-600 font-bold text-xs">
                  {moment(x?.TestFromDate?.iso)
                    .utc()
                    .format("DD/MM/YYYY hh:mm A")}{" "}
                  -{" "}
                  {moment(x?.TestToDate?.iso)
                    .utc()
                    .format("DD/MM/YYYY hh:mm A")}
                </span>
              )}
              {/* Tag indicating free or paid */}
              <div className="absolute top-2 right-2 bg-green-500 text-white text-xs font-bold uppercase px-2 py-1 rounded">
                {x?.TestPaidType}
              </div>
            </div>
          </div>
        ))
      ) : (
        <span className="font-semibold text-lg">no data found!</span>
      )}
      {isAlreadySummited && (
        <ToastNotification
          showToast={isAlreadySummited}
          message={testResult?.message}
        />
      )}
    </div>
  );
};

export default TestPage;
